/**
 * Stores the Activity Bar state
 */
import { ref } from "vue";
import { defineStore } from "pinia";
import { Activities } from "./activitySetup";
export const useActivityStore = defineStore("activityStore", () => {
    const activities = ref([]);
    /**
     * The set of built-in activities is defined in activitySetup.js.
     * This helper function applies changes of the built-in activities,
     * to the user stored activities which are persisted in local cache.
     */
    function sync() {
        // create a map of built-in activities
        const activitiesMap = {};
        Activities.forEach((a) => {
            activitiesMap[a.id] = a;
        });
        // create an updated array of activities
        const newActivities = [];
        const foundActivity = new Set();
        activities.value.forEach((a) => {
            if (a.mutable) {
                // existing custom activity
                newActivities.push(Object.assign({}, a));
            }
            else {
                // update existing built-in activity attributes
                // skip legacy built-in activities
                const sourceActivity = activitiesMap[a.id];
                if (sourceActivity) {
                    foundActivity.add(a.id);
                    newActivities.push(Object.assign(Object.assign({}, sourceActivity), { visible: a.visible }));
                }
            }
        });
        // add new built-in activities
        Activities.forEach((a) => {
            if (!foundActivity.has(a.id)) {
                newActivities.push(Object.assign({}, a));
            }
        });
        // update activities stored in local cache only if changes were applied
        if (JSON.stringify(activities.value) !== JSON.stringify(newActivities)) {
            activities.value = newActivities;
        }
    }
    function getAll() {
        return activities.value;
    }
    function setAll(newActivities) {
        activities.value = newActivities;
    }
    function remove(activityId) {
        const findIndex = activities.value.findIndex((a) => a.id === activityId);
        if (findIndex !== -1) {
            activities.value.splice(findIndex, 1);
        }
    }
    return {
        activities,
        getAll,
        remove,
        setAll,
        sync,
    };
}, {
    persist: {
        paths: ["activities"],
    },
});
